import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { PiralInstance, StateContext } from 'piral-core';
import { ScrollToTop } from '@smapiot/components';
import { Layout } from './layout/AnonymousLayout';
import { Router } from './components/Router';
import { routes } from './routes';
import FallbackPage from './pages/Fallback';

const Status = React.lazy(() => import('./pages/Status'));

export interface AnonymousAppProps {
  pages: Record<string, React.FC>;
  instance: PiralInstance;
}

const AnonymousApp: React.FC<AnonymousAppProps> = ({ instance, pages }) => (
  <StateContext.Provider value={instance.context}>
    <Router>
      <Route component={ScrollToTop} />
      <Layout>
        <Switch>
          {Object.keys(pages).map(route => (
            <Route exact key={route} path={route} component={pages[route]} />
          ))}
          <Route exact path={routes.status} component={Status} />
          <Route component={FallbackPage} />
        </Switch>
      </Layout>
    </Router>
  </StateContext.Provider>
);

export default AnonymousApp;
